import templateUrl from './login.html';

export default {
  templateUrl,
  controller: class LoginFormComponent {
    constructor($state, AuthService, ToastService) {
      'ngInject';

      Object.assign(this, { $state, AuthService, ToastService });
    }

    $onInit() {
      this.loginEnabled = true;
      this.loginError = {};
    }

    forgotPassword() {
      this.$state.go('forgotPassword', { userName: this.userName });
    }

    onSubmit() {
      this.loginEnabled = false;
      this.loginError = {};
      this.AuthService.login({
        userName: this.userName,
        password: this.password
      })
        .then(() => {
          this.$state.go('app');
        })
        .catch((e) => {
          if (e && e.data && e.data.error_description) {
            if (e.data.error_description === 'Invalid Credentials') {
              // const msg = 'The username or password you entered is incorrect.';
              // this.ToastService.showError(e, msg);
              this.loginError.invalidCredentials = true;
            } else if (e.data.error_description === 'Force Password Reset') {
              this.$state.go('resetPassword', { userName: this.userName });
            } else {
              this.ToastService.showError(e, e.data.error_description);
            }
          } else {
            this.ToastService.showError(e);
          }

          this.loginEnabled = true;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./components/auth/login/login.component.js